import React, { createContext, useState, useContext } from "react";
import axios from "axios";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const {
    REACT_APP_DB,
    REACT_APP_PORT_FRONT,
    REACT_APP_PORT_BACK,
    REACT_APP_PORT_HTTP,
    REACT_APP_FROM,
  } = process.env;

  // ------------------ LOGIN ------------------
  const login = async (username, password) => {
    console.log("Before axios post", username, password);
    try {
      const url =
        REACT_APP_FROM === "local"
          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/login`
          : `/api/login`;

      const response = await axios.post(url, { username, password });
      console.log("After axios post login", response.data);

      if (response.data.success) {
        setIsAuthenticated(true);
        // return true;
        return response.data;
      } else {
        console.log(response.data.message);
        return false;
      }
    } catch (error) {
      if (error.response) {
        console.error("Login error response data:", error.response.data);
        console.error("Login error response status:", error.response.status);
      } else if (error.request) {
        console.error("Login error request no response:", error.request);
      } else {
        console.error("Login error message:", error.message);
      }
      return false;
    }
  };

  // ------------------ LOGOUT ------------------
  const logout = () => {
    setIsAuthenticated(false);
  };

  // ------------------ RESET PASSWORD ------------------
  const resetPassword = async (email) => {
    console.log("Reset password called for:", email);
    try {
      const url =
        REACT_APP_FROM === "local"
          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/send-reset-link`
          : `/api/send-reset-link`;

      const response = await axios.post(url, { email });

      console.log("Reset password response:", response.data);

      if (response.data.success) {
        return true; // ส่งอีเมลสำเร็จ
      } else {
        console.warn(response.data.message);
        return false;
      }
    } catch (error) {
      if (error.response) {
        console.error("Reset error response:", error.response.data);
      } else if (error.request) {
        console.error("Reset error request no response:", error.request);
      } else {
        console.error("Reset error message:", error.message);
      }
      return false;
    }
  };

  // ------------------ REQUEST EMAIL VERIFICATION ------------------
  const requestEmailVerification = async (username, email) => {
    console.log("begin Request email verification:");
    try {
      const url =
        REACT_APP_FROM === "local"
          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/auth/request-email-verification`
          : `/api/auth/request-email-verification`;

      const response = await axios.post(url, {
        username,
        email,
      });

      console.log("Request email verification:", response.data);

      return response.data;
    } catch (error) {
      console.error(
        "Request email verification error:",
        error.response?.data || error.message,
      );

      return {
        success: false,
        message: "Unable to send verification code",
      };
    }
  };

  // ------------------ VERIFY EMAIL ------------------
  const verifyEmail = async (username, email, otp) => {
    try {
      const url =
        REACT_APP_FROM === "local"
          ? `http://${REACT_APP_DB}:${REACT_APP_PORT_BACK}/api/auth/verify-email`
          : `/api/auth/verify-email`;

      const response = await axios.post(url, {
        username,
        email,
        otp,
      });

      console.log("Verify email response:", response.data);

      return response.data;
    } catch (error) {
      console.error(
        "Verify email error:",
        error.response?.data || error.message,
      );

      return {
        success: false,
        message: "Unable to verify email",
      };
    }
  };

  // ✅ ต้อง “เพิ่ม resetPassword” เข้าไปใน value ด้วย
  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        login,
        logout,
        resetPassword, // 👈 เพิ่มตรงนี้
        requestEmailVerification,
        verifyEmail,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
